import React, { useEffect, useState } from "react";

import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { IconProp } from "@fortawesome/fontawesome-svg-core";

interface ITabsProps {
    tabs: Array<{
        key: string;
        name: string;
        icon: IconProp;
        Component: React.FC<any>;
        loaded?: boolean;
    }>;
    inicial?: string;

    cardClasses?: string;
}

/**
 *
 * @todo Descobrir por que o uso do componente causa várias re-renders sem necessidade sem que sejam usados states externos
 */
export default function Tabs(props: ITabsProps) {
    const [tabKey, setTabKey] = useState(props.inicial);

    useEffect(() => {
        if (props.tabs[0]) {
            props.tabs[0].loaded = true;
            setTabKey(props.tabs[0].key);
        }
    }, [props.tabs]);

    return (
        <>
            <ul className="nav nav-tabs">
                {props.tabs?.map((tab) => (
                    <li
                        key={tab.key}
                        className="nav-item"
                        onClick={() => {
                            setTabKey(tab.key);
                            tab.loaded = true;
                        }}
                        role="button"
                    >
                        <span
                            className={`nav-link ${
                                tabKey === tab.key && "active"
                            }`}
                        >
                            <FontAwesomeIcon icon={tab.icon} className="mr-2" />
                            {tab.name}
                        </span>
                    </li>
                ))}
            </ul>
            <div
                className={
                    props.cardClasses ?? "tab-content card card-custom p-3"
                }
            >
                {props.tabs?.map((tab) => {
                    return (
                        <span key={tab.key}>
                            {(tab.key === tabKey || tab.loaded) && (
                                <div
                                    className={
                                        tab.key !== tabKey ? "d-none" : ""
                                    }
                                >
                                    <tab.Component key={tab.key} />
                                </div>
                            )}
                        </span>
                    );
                })}
            </div>
        </>
    );
}
